<template>
  <div class="container">
    <h1 class="subs-title">{{ getTitle() }}</h1>
    <text-field v-model="form.name" :validator="$v.form.name" label="Membership name*" />
    <div class="input-container">
      <datetime-field
        v-model="form.from"
        :validator="$v.form.from"
        style="width: 100%"
        label="From*"
        :min="new Date().toString()"
        :error-messages="{
          minDate: 'Start date must be a future date',
          maxDate: 'Start date should be before the end of the event',
        }"
      />
      <datetime-field
        v-model="form.to"
        :validator="$v.form.to"
        style="width: 100%"
        label="To*"
        :min="form.from ? form.from.toString() : new Date().toString()"
        :error-messages="{
          minDate: 'End date should not be before the start of the event',
        }"
      />
    </div>
    <div class="input-container">
      <text-field
        v-model.number="form.price"
        :validator="$v.form.price"
        type="number"
        step="0.01"
        label="Price (EUR)*"
      />
    </div>
    <select-field-multiple
      v-if="!excludeOrderItemTemplates"
      v-model="form.orderItemTemplates"
      label="Choose Ticket type*"
      :items="orderItemTemplates"
      item-render="name"
      item-select="id"
      :validator="$v.form.orderItemTemplates"
    />
    <p
      v-if="!excludeOrderItemTemplates"
      class="ticket-type-note"
      :style="$v.form.orderItemTemplates.$invalid && 'margin-top: -1.5rem'"
    >
      If the Ticket type is not on the list, check if it is marked as Membership only.
    </p>
    <div v-if="!excludeOrderItemTemplates" class="input-container">
      <text-field
        v-model.number="form.amount"
        :validator="$v.form.amount"
        type="number"
        step="1"
        label="Amount of Tickets*"
      />
      <text-field disabled placeholder="Per every included month" label="Available*" />
    </div>
    <cover-field
      v-if="includeCoverImageField"
      v-model="form.imageUrl"
      :validator="$v.form.imageUrl"
    />
    <textarea-field
      v-model="form.description"
      :validator="$v.form.description"
      label="Description"
      height="13.75rem"
    />
    <div class="buttons-wrapper" style="margin-top: 58px">
      <main-button text="CANCEL" flat depressed @click="$emit('cancel')" />
      <div class="buttons">
        <main-button :text="buttonName" @click="handleCreate" />
      </div>
    </div>
  </div>
</template>

<script>
import { required, requiredIf } from 'vuelidate/lib/validators'
import {  submitGuard } from '@/utils'

export default {
  name: 'create-or-edit-membership',
  components: {},
  props: {
    initialValue: {
      type: Object,
      default: () => {},
    },
    orderItemTemplates: {
      type: Array,
      default: () => [],
    },
    excludeOrderItemTemplates: {
      type: Boolean,
      default: () => false,
    },
    includeCoverImageField: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      form: { ...this.initialValue },
      buttonName: 'Create plan',
      emitType: 'create',
      attendeeFields: {},
    }
  },
  validations() {
    return {
      form: {
        name: { required },
        price: { required },
        from: { required },
        to: { required },
        amount: { required: requiredIf(() => !this.excludeOrderItemTemplates) },
        orderItemTemplates: { required: requiredIf(() => !this.excludeOrderItemTemplates) },
        imageUrl: { required: requiredIf(() => this.includeCoverImageField) },
      },
    }
  },
  methods: {
    getTitle() {
      if (Object.keys(this.initialValue).length) {
        this.buttonName = 'Update'
        this.emitType = 'update'

        return 'Edit Membership Plan'
      } else {
        return 'Create a new Membership Plan'
      }
    },
    handleCreate() {
      submitGuard(this, () => this.$emit(this.emitType, this.form))
    },
  },
}
</script>

<style scoped>
.ticket-type-note {
  font-family: Roboto;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1rem;
  color: #666;
  text-indent: 1rem;
  margin-top: -2.5rem;
}
.container {
  padding: 0 !important;
  margin: 0 !important;
  display: flex;
  flex-direction: column;
  max-width: 43.75rem;
  row-gap: 2rem;
}
.subs-title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 120%;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #ff4c00;
  margin-bottom: 1.5rem;
}
.input-container {
  display: flex;
  justify-content: space-between;
  width: 100%;
  column-gap: 1.5rem;
}
</style>
